<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import OnboardingStepLayout from './OnboardingStepLayout.vue';
import { useRegisterOnboardingNav } from '../useOnboardingNav';

const store = useStore();
const { t } = useI18n();

const uiFlags = computed(() => store.state.onboarding.uiFlags);
const error = computed(() => store.state.onboarding.error);

const assistantName = computed({
  get: () =>
    store.state.onboarding.assistantName ||
    store.getters['onboarding/suggestedAssistantName'],
  set: value => store.dispatch('onboarding/setAssistantName', value),
});

const continueSetup = () => store.dispatch('onboarding/saveAssistant');

const skipAssistant = () => store.dispatch('onboarding/skipAssistant');

useRegisterOnboardingNav(() => ({
  secondary: {
    label: t('ONBOARDING_WIZARD.SKIP'),
    loading: uiFlags.value.isProvisioning,
    onClick: skipAssistant,
  },
  primary: {
    label: t('ONBOARDING_WIZARD.CONTINUE'),
    loading: uiFlags.value.isSaving,
    onClick: continueSetup,
  },
}));

const inputClass =
  'w-full h-12 px-4 text-base rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-woot-500 !mb-0';
</script>

<template>
  <OnboardingStepLayout
    :step-label="t('ONBOARDING_WIZARD.OVERVIEW.PHASES.starting_with_ai.TITLE')"
    :title="t('ONBOARDING_WIZARD.ASSISTANT.TITLE')"
    :description="t('ONBOARDING_WIZARD.ASSISTANT.DESCRIPTION')"
  >
    <div class="w-full flex flex-col gap-2">
      <label class="text-sm font-semibold text-slate-700 dark:text-slate-200">
        {{ t('ONBOARDING_WIZARD.ASSISTANT.NAME_LABEL') }}
      </label>
      <input
        v-model="assistantName"
        type="text"
        required
        :class="inputClass"
        :placeholder="t('ONBOARDING_WIZARD.ASSISTANT.NAME_PLACEHOLDER')"
      />
      <p v-if="error" class="text-sm text-red-600 dark:text-red-400 m-0">
        {{ error }}
      </p>
    </div>
  </OnboardingStepLayout>
</template>
